var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199 207.9",
    style: {
      enableBackground: "new 0 0 199 207.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#04E6D4;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:24.857,8.7;}\n\t.st1{fill:none;stroke:#04E6D4;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#04E6D4;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:2.485,3.729;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 69.2,
    y1: 34.7,
    x2: 0.2,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 198.5,
    y1: 0.1,
    x2: 109.7,
    y2: 208.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.2,
    y1: 11,
    x2: 65.3,
    y2: 181.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign3);
export default __webpack_public_path__ + "static/media/sign3.70cfe5aab3dc3c7087eb2d4e36510196.svg";
export { ForwardRef as ReactComponent };